<template>
  <div class="financeManage-transactionHold-page">
    <p class="hasBottomLine"><span class="link-wrap" @click="toGoRuturn()">持仓管理 > </span>项目方明细</p>
    <!-- <div class="header-seach-box">
          <div class="inputWithSelectBox">
            <el-input placeholder="请输入币名称"  v-model="serchInfo.selectCoin" class="input-with-select">
              <el-button slot="append" disabled @click="getPageListInfo()" icon="el-icon-search">搜索</el-button>
            </el-input>
          </div>
        </div> -->
    <div class="table-box">
      <el-table :data="getProjectList2Info" border style="width: 99.9%">
        <!-- <el-table-column prop="mortgageCoin" label="序号"> </el-table-column> -->
        <el-table-column prop="userId" label="账号ID" />

        <el-table-column prop="projectName" label="项目方名称" />

        <el-table-column prop="coinAmount" :label="'可用备付金 -' + $route.query.coinType"> </el-table-column>
        <el-table-column prop="coinFroze" :label="'冻结备付金 -' + $route.query.coinType"> </el-table-column>

        <el-table-column prop="maxCoinPosition" label="项目方最大持仓量"></el-table-column>
        <el-table-column prop="longPosition" label="用户多头持仓"></el-table-column>
        <el-table-column prop="shortPosition" label="用户空头持仓"></el-table-column>

        <el-table-column prop="maxDay" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="primary" @click="showListBtn(scope.row)">持仓明细</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer-box">
      <el-pagination
        @size-change="sizeChange1"
        @current-change="pageChange1"
        :current-page.sync="currentPage1"
        :page-size="pageSize1"
        layout="total, prev, pager, next"
        :total="getProjectList2Total"
      >
      </el-pagination>
    </div>

    <el-dialog title="全部订单" class="bk-table-dialog" :before-close="closeDialog" :visible.sync="orderListDialog">
      <div class="dialogHeader">
        <div class="header-seach-box">
          <div class="setDatePicker">
            <span class="setPading">方向</span>
            <el-select v-model="serchDirection" slot="prepend" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="多头" value="LONG"></el-option>
              <el-option label="空头" value="SHORT"></el-option>
            </el-select>
          </div>

          <div class="setDatePicker">
            <span class="setPading">订单状态：</span>
            <el-select v-model="serchStatus" slot="prepend" placeholder="请选择">
              <el-option label="已平仓" value=""></el-option>
              <el-option label="持仓中" value="0"></el-option>
              <el-option label="一键平仓" value="1"></el-option>
              <el-option label="平仓中" value="2"></el-option>
              <el-option label="爆仓强平" value="3"></el-option>
              <el-option label="止盈强平" value="4"></el-option>
              <el-option label="止盈止损强平" value="5"></el-option>
            </el-select>
          </div>
        </div>
        <div class="header-seach-box">
          <div class="setDatePicker">
            <span class="setPading">查询为开仓时间（下载为平仓时间）</span>
            <el-date-picker
              v-model="serchTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :picker-options="pickerOptions"
              value-format="timestamp"
            />
          </div>

          <div class="inpuBox">
            <el-input v-model="serchUserId" placeholder="客户ID"></el-input>
          </div>

          <div class="setDatePicker" style="margin-left:30px">
            <el-button type="primary" round @click="getPageListInfo()">搜索</el-button>
            <el-button type="success" round @click="clearSearh()">清空筛选条件</el-button>
            <el-button type="warning" round @click="downloadHold()">数据下载</el-button>
          </div>

          <!-- <el-button type="success" class="toTransLfet" @click="editBtn({}, 'add')">添加方案</el-button> -->
        </div>
      </div>
      <el-table :data="contractOrderListInfo">
        <el-table-column property="userId" label="客户ID" width="160" />
        <el-table-column property="createTime" width="180" label="开仓时间">
          <template slot-scope="scope">
            <span> {{ scope.row.createTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column property="direction" label="方向">
          <template slot-scope="scope">
            <span v-if="scope.row.direction === 'LONG'">多头</span>
            <span v-if="scope.row.direction === 'SHORT'">空头</span>
          </template>
        </el-table-column>
        <el-table-column property="amount" label="开仓数量"></el-table-column>

        <el-table-column property="leverage" label="杠杆比例（%）" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.leverage }} X</span>
          </template>
        </el-table-column>

        <el-table-column property="openPrice" label="开仓价格"></el-table-column>
        <el-table-column property="nowPrice" label="当前价格"></el-table-column>
        <el-table-column property="profitRate" label="盈亏率">
          <template slot-scope="scope">
            <span v-if="scope.row.profitRate < 0" style="color:red">{{ scope.row.profitRate }}</span>
            <span v-else style="color:#55A955">{{ scope.row.profitRate }}</span>
          </template>
        </el-table-column>
        <el-table-column property="profit" label="盈亏值">
          <template slot-scope="scope">
            <span v-if="scope.row.profit < 0" style="color:red">{{ scope.row.profit }}</span>
            <span v-else style="color:#55A955">{{ scope.row.profit }}</span>
          </template>
        </el-table-column>

        <el-table-column property="address" label="当前状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0"> 持仓中</span>
            <span v-if="scope.row.status === 1"> 一键平仓</span>
            <span v-else-if="scope.row.status === 2"> 平仓中</span>
            <span v-else-if="scope.row.status === 3"> 爆仓强平</span>
            <span v-else-if="scope.row.status === 4"> 止盈强平</span>
            <span v-else-if="scope.row.status === 5"> 止盈止损强平</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="maxDay" label="操作" width="200">
                  <template slot-scope="scope">
                    <el-button type="primary" @click="showDetailBtn(scope.row)">订单明细</el-button>
                  </template>
                </el-table-column> -->
      </el-table>
      <div class="footer-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="pageChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :page-sizes="[1, 10, 50, 100, 200, 400, 800, 1000]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="contractOrderListTotal"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "../store";
import api from "../api";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "transactionHold",
  data() {
    return {
      orderListDialog: false,
      borrowCoinParam: "",
      mortgageCoinParam: "",

      selectType: "1",
      serchInput: "",

      serchStartTime: "",
      serchEndTime: "",
      defaultProjectUserId: "",

      currentPage: 1,
      pageSize: 10,
      currentPage1: 1,
      pageSize1: 10,
      serchDirection: "",
      serchStatus: "0",
      serchUserId: "",
      serchCoinType: "",
      serchTime: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              let year = end.getFullYear();
              let month = end.getMonth();
              let date = end.getDate();
              const start = new Date(year, month, date);
              start.setTime(start.getTime());
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三天",
            onClick(picker) {
              const end = new Date();
              let year = end.getFullYear();
              let month = end.getMonth();
              let date = end.getDate();
              const start = new Date(year, month, date);
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              let year = end.getFullYear();
              let month = end.getMonth();
              let date = end.getDate();
              const start = new Date(year, month, date);
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    ...mapState("FinanceManage", [
      "getProjectList2Info",
      "getProjectList2Total",
      "contractOrderListInfo",
      "contractOrderListTotal"
    ])
  },
  methods: {
    ...mapActions("FinanceManage", ["getProjectList2", "getHoldOrderList"]),
    hanldSelectType() {
      this.serchInfo.selectCoin = "";
    },
    sizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pageSize = val;
        this.getPageListInfo();
    },
    pageChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
        this.getPageListInfo();
    },

    sizeChange1(val) {
      console.log(`每页 ${val} 条`);
    },
    pageChange1(val) {
      console.log(`当前页: ${val}`);
      this.getProjectListInfo();
      // this.getPageListInfo();
    },

    showListBtn(row) {
      let that = this;
      this.orderListDialog = true;
      this.serchCoinType = row.coinType;
      // this.serchUserId=row.userId;
      this.defaultProjectUserId = row.userId;
      this.getPageListInfo();
    },
    getPageListInfo() {
      let postData = {
        page: this.currentPage,
        size: this.pageSize,
        coinType: this.serchCoinType,
        status: this.serchStatus,
        direction: this.serchDirection,
        userId: this.serchUserId,
        projectUserId: this.defaultProjectUserId
      };
      if (this.serchTime) {
        postData.endTime = this.serchTime[1];
        postData.startTime = this.serchTime[0];
      }
      this.getHoldOrderList(postData);
    },
    handleSearch() {},
    clearSearh() {
      this.serchStatus = "0";
      this.serchDirection = "";
      this.serchEndTime = "";
      this.serchStartTime = "";
      this.serchUserId = "";
      this.serchTime = [];
      this.getPageListInfo();
    },

    closeDialog() {
      this.orderListDialog = false;
      this.clearSearh();
    },

    showDetailBtn(row) {
      this.toGoDetailPage(row.id);
    },
    toGoDetailPage(id) {
      this.$router.push("/home/finance/manage/mortgage/orderDetail?id=" + id);
    },
    downloadHold() {
      let data = {
        coinType: this.serchCoinType,
        userId: this.serchUserId
      };
      if (this.serchTime) {
        data.endTime = this.serchTime[1];
        data.startTime = this.serchTime[0];
      }
      api.exportTransaction(data).then(response => {
        const fileName = "超级合约交易持仓明细.xlsx";
        const blob = new Blob([response], { type: "application/vnd.ms-excel" });
        if ("download" in document.createElement("a")) {
          const link = document.createElement("a");
          link.download = fileName;
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
        } else {
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },

    toGoRuturn() {
      this.$router.push("/home/finance/manage/mortgage/transactionHold");
    },

    getProjectListInfo() {
      let that = this;
      this.getProjectList2({
        configId: this.$route.query.configId,
        page: that.currentPage1,
        size: that.pageSize1
      });
    }
  },
  created() {},
  mounted() {
    this.getProjectListInfo();
  }
};
</script>

<style lang="less">
.financeManage-transactionHold-page {
  width: 100%;
  height: 500px;

  .hasBottomLine {
    width: 100%;
    padding-bottom: 18px;
    font-size: 18px;
    margin-bottom: 18px;
    font-weight: bold;
    border-bottom: 1px solid #cccccc;
    .link-wrap {
      color: #6385ed;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
    }
  }

  .header-seach-box {
    width: 100%;
    margin-bottom: 30px;
    display: flex;

    .inputWithSelectBox {
      width: 500px;
      display: flex;

      .el-input-group__prepend {
        .el-select {
          width: 120px;
        }
      }

      .el-input-group__append {
        background: #409eff;
        color: #ffffff;
      }
    }

    .toTransLfet {
      margin-left: 30px;
    }

    .setSelect {
      margin-left: 30px;

      .el-select {
        margin-left: 12px;
      }
    }
  }

  .table-box {
    width: 100%;
    overflow: hidden;

    .el-table {
      .el-table__header-wrapper {
        .el-table__header {
          text-align: center;

          .cell {
            text-align: center;
          }
        }
      }

      .el-table__body-wrapper {
        .cell {
          text-align: center;
        }
      }
    }
  }

  .footer-box {
    padding: 20px 20px 50px 0px;
  }

  .configItem {
    margin-bottom: 50px;
    padding-bottom: 30px;
    border-bottom: 1px solid #cccccc;

    .item-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 18px;
      display: flex;
      align-items: center;

      .el-button {
        margin-left: 50px;
      }
    }

    .item-action {
      display: flex;

      .desc-box {
        margin-right: 30px;

        .imitateInput {
          min-width: 60px;
          padding: 12px 20px;
          display: inline-block;
          text-align: center;
          border: 1px solid #cccccc;
          margin: 0 12px 0;
        }
      }

      .el-switch.is-disabled {
        opacity: 1;
      }

      .el-switch .is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }

      .el-switch.is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }
    }

    .item-remark {
      color: #ff8839;
      padding: 1px 0 22px 0;
    }
  }

  .bk-table-dialog {
    .el-dialog {
      width: 70%;

      .el-dialog__header {
        text-align: center;
        color: red;
      }

      .el-dialog__body {
        .dialogHeader {
          width: 100%;

          .header-seach-box {
            .setDatePicker {
              padding-right: 20px;

              .setPading {
                padding: 0 12px;
              }
            }
          }
        }

        .el-table {
          .el-table__header-wrapper {
            .el-table__header {
              text-align: center;

              .cell {
                text-align: center;
              }
            }
          }

          .el-table__body-wrapper {
            .cell {
              text-align: center;
            }
          }
        }
      }

      .el-dialog__footer {
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
